import { useTranslate } from "@refinedev/core";
import { Col, Flex, Row } from "antd";
import { SectionTitle } from "@libertify/ui";
import { Tutorial } from "../tutorials.data";
import { TutorialCard } from "./TutorialCard";

export type TutorialSectionProps = {
  title: string;
  tutorials: Tutorial[];
  onSelect: (tutorial: Tutorial, lessonNumber: number) => void;
};

export const TutorialSection = ({
  title,
  tutorials,
  onSelect,
}: TutorialSectionProps) => {
  const t = useTranslate();

  return (
    <Flex vertical gap={16}>
      <SectionTitle>{title}</SectionTitle>
      <Row gutter={[28, 28]}>
        {tutorials.map((tutorial, index) => (
          <Col key={tutorial.titleKey} xs={24} sm={12} lg={8}>
            <TutorialCard
              status="ready"
              lessonNumber={index + 1}
              title={t(tutorial.titleKey)}
              thumbnailUrl={tutorial.thumbnailUrl}
              onClick={() => onSelect(tutorial, index + 1)}
            />
          </Col>
        ))}
      </Row>
    </Flex>
  );
};
